import { BackgroundColorVariant } from '../types/colorVariant';

export const mapToBackgroundClass = (
	backgroundColorVariant?: BackgroundColorVariant,
) => {
	switch (backgroundColorVariant) {
		default:
		case 'primary':
			return 'bg-primary-teal';

		case 'secondary':
			return 'bg-white';
	}
};
